export default "/images/room_tour_3d.svg?b19d21e7d740cd2a23724c53020e7be8";